/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageMetadata } from './PageMetadata';
import {
    PageMetadataFromJSON,
    PageMetadataFromJSONTyped,
    PageMetadataToJSON,
    PageMetadataToJSONTyped,
} from './PageMetadata';
import type { ConfigResponse } from './ConfigResponse';
import {
    ConfigResponseFromJSON,
    ConfigResponseFromJSONTyped,
    ConfigResponseToJSON,
    ConfigResponseToJSONTyped,
} from './ConfigResponse';

/**
 * 
 * @export
 * @interface PagedModelConfigResponse
 */
export interface PagedModelConfigResponse  {
    /**
     * 
     * @type {Array<ConfigResponse>}
     * @memberof PagedModelConfigResponse
     */
    content?: Array<ConfigResponse>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelConfigResponse
     */
    page?: PageMetadata;
}

/**
 * Check if a given object implements the PagedModelConfigResponse interface.
 */
export function instanceOfPagedModelConfigResponse(value: object): value is PagedModelConfigResponse {
    return true;
}

export function PagedModelConfigResponseFromJSON(json: any): PagedModelConfigResponse {
    return PagedModelConfigResponseFromJSONTyped(json, false);
}

export function PagedModelConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedModelConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ConfigResponseFromJSON)),
                  'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}

export function PagedModelConfigResponseToJSON(json: any): PagedModelConfigResponse {
    return PagedModelConfigResponseToJSONTyped(json, false);
}

export function PagedModelConfigResponseToJSONTyped(value?: PagedModelConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(ConfigResponseToJSON),
        'page': PageMetadataToJSON(value['page']),
    };
}


